<template>
	<popupLayout>
		<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="$parent.showAssistStateControl(false);">×</button>
		<header class="text-center">
			<h4 v-if="type == 'relief'">查詢學雜費減免申請</h4>
			<h4 v-if="type == 'weak'">查詢弱勢助學金申請</h4>
      <h4 v-if="type == 'lifeworkstudy'">查詢生活助學金申請</h4>
		</header>
		<div class="bootbox-body">
			<div class="row form-group mb-lg">

				<div class="col-md-12">
					<label class="col-md-4">身分證字號:</label>
					<div class="col-md-8">
						<input type="text" v-model="idno" class="form-control"/>
					</div>

				</div>
				<div class="col-md-12">
					<h4>{{resultState}}</h4>
				</div>
			</div>
			<div class="row">
				<div class="col-md-offset-4 col-md-4">
					<div class=" col-md-offset-3 col-md-6">
						<a class="btn btn-danger btn-block" @click="sreachStayState">送出</a>
					</div>
				</div>
			</div>
		</div>
	</popupLayout>
</template>
<script>
import popupLayout from './popupLayout';
export default {
	props:['type'],
	components:{
		popupLayout
	},
	data(){
		return {
			idno:"",
			resultState:"",
		}
	},
	methods:{
		sreachStayState(){
			if(!this.idno){
				bootbox.alert("請輸入身分證字號");
			}else{
        if(this.type == 'relief') {
          if(this.$route.name == 'relief.list'){
            this.setStore('relief.list', {idNo: this.idno});
            this.$router.go();
          } else {
            this.gotoView('relief.list', {idNo: this.idno});
          }
        } else if (this.type == 'weak') {
          if(this.$route.name == 'weak.list'){
            this.setStore('weak.list', {idNo: this.idno});
            this.$router.go();
          } else {
            this.gotoView('weak.list', {idNo: this.idno});
          }
        } else if (this.type == 'lifeworkstudy') {
          this.gotoView('/workstudy/life/list', {idNo: this.idno});
        }

				this.$parent.showAssistStateControl(false);
			}
		}
	}
}
</script>
